import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { isMobile, SERVER_URL } from '../../config';
import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import { fetchInquiryDetailData } from '../../services/inquiryService';
import { formatDate } from '../../utils/date'

import HeaderComponents from '../../components/Header/HeaderComponents';
import SideBannerComponents from '../../components/SideBanner/SideBannerComp';


import S from './Support.module.css';
import BasicTable from '../../components/Table/BasicTable';
import useInput from '../../hooks/useInput';
import { isNull } from '../../utils/util';
import BackListBtn from '../../components/Button/BackListBtn';

const InquiryDetailPage = () => {
  
  const { idx } = useParams();
  const [ inquiry, setInquiry ] = useState([]);
  const [ iqFile, setIqFile ] = useState([]);
  const [ iqCert, setIqCert ] = useState(false);
  const [ iqPwd, setIqPwd ] = useInput({ pwd: ''});
  const [ asBodyData, setAsBodyData ] = useState([]);
  
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 327);
    
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);
  
  const headerData = [
    { text: '', value: 'title1', widthClass: 'inquertRegHeader' },
    { text: '', value: 'content1', widthClass: 'inquertRegHeader' },
    { text: '', value: 'title2', widthClass: 'inquertRegHeader' },
    { text: '', value: 'content2', widthClass: 'inquertRegHeader' },
  ]

  const handelPwdSubmit = () => {
    if (iqPwd.pwd === inquiry.IQ_PWD) {
      setIqCert(true);
    } else {
      alert('틀린 비밀번호를 입력하였습니다.');
    }
  }
  
  const handlePreviousPage = () => {
    navigate('/support/inquiry/1');
  };

  const bodyData = [
    {
      title1: { text: '제목', className: 'iqTableBorder' ,url: null},
      content1: { text: inquiry.IQ_TITLE ? inquiry.IQ_TITLE : '', colSpan: 3, className: 'iqDetailTableBodyBorder' },
      title2: { text: null },
      content2: { text: null },
    },
    {
      title1: { text: '업체명', className: 'iqDetailTableHeadBorder' },
      content1: { text: inquiry.IQ_COMPANY_NAME, className: 'iqDetailTableBodyBorder' },
      title2: { text: '담당자명', className: 'iqDetailTableHeadBorder' },
      content2: { text: inquiry.IQ_STAFF_NAME, className: 'iqDetailTableBodyBorder' },
    },
    {
      title1: { text: '연락처', className: 'iqTableBorder' },
      content1: { text: inquiry.IQ_PHONE, className: 'iqDetailTableBodyBorder' },
      title2: { text: '이메일', className: 'iqTableBorder' },
      content2: { text: inquiry.IQ_EMAIL, className: 'iqDetailTableBodyBorder' },
    },
    {
      title1: { text: '사용용도', className: 'iqTableBorder' },
      content1: { text: inquiry.IQ_USE ? inquiry.IQ_USE : '', className: 'iqDetailTableBodyBorder' },
      title2: { text: '구매제품', className: 'iqTableBorder' },
      content2: { text: inquiry.IQ_PRD ? inquiry.IQ_PRD : '', className: 'iqDetailTableBodyBorder' },
    },
    {
      title1: { text: '제품수량', className: 'iqTableBorder' },
      content1: { text: inquiry.IQ_QUANTITY ? inquiry.IQ_QUANTITY : '', className: 'iqDetailTableBodyBorder' },
      title2: { text: '작성일', className: 'iqTableBorder' },
      content2: { text: formatDate(inquiry.IQ_INPUT_DATE), className: 'iqDetailTableBodyBorder' },
    },
    {
      title1: { text: '문의내용', className: 'iqTableBorder' },
      content1: { text: (<div dangerouslySetInnerHTML={{ __html: inquiry.IQ_CONTENT }} ></div>)
      , colSpan: 3, className: 'iqAsTitleTableBodyBorder' },
      title2: { text: null },
      content2: { text: null },
    },
    {
      title1: { text: '첨부파일', className: 'iqTableBorder' },
      content1: { text: 
      (<div>
        {iqFile && iqFile.map((file, index) => (
          <div key={file.IF_IDX}>
            <a href={SERVER_URL + file.IF_PATH} target='_blank'>첨부파일 {index+1}</a>
          </div>
        ))}
      </div>), colSpan: 3, className: 'iqDetailTableBodyBorder' },
      title2: { text: null },
      content2: { text: null },
    },
  ];

  const mbBodyData = [
    {
      title1: { text: '제목', className: 'iqTableBorder' ,url: null},
      content1: { text: inquiry.IQ_TITLE ? inquiry.IQ_TITLE : '', colSpan: 3, className: 'iqDetailTableBodyBorder' },
      title2: { text: null },
      content2: { text: null },
    },
    {
      title1: { text: '업체명', className: 'iqTableBorder' ,url: null},
      content1: { text: inquiry.IQ_COMPANY_NAME ? inquiry.IQ_COMPANY_NAME : '', colSpan: 3, className: 'iqDetailTableBodyBorder' },
      title2: { text: null },
      content2: { text: null },
    },
    {
      title1: { text: '담당자명', className: 'iqTableBorder' ,url: null},
      content1: { text: inquiry.IQ_STAFF_NAME ? inquiry.IQ_STAFF_NAME : '', colSpan: 3, className: 'iqDetailTableBodyBorder' },
      title2: { text: null },
      content2: { text: null },
    },
    {
      title1: { text: '연락처', className: 'iqTableBorder' ,url: null},
      content1: { text: inquiry.IQ_PHONE ? inquiry.IQ_PHONE : '', colSpan: 3, className: 'iqDetailTableBodyBorder' },
      title2: { text: null },
      content2: { text: null },
    },
    {
      title1: { text: '이메일', className: 'iqTableBorder' ,url: null},
      content1: { text: inquiry.IQ_PHONE ? inquiry.IQ_PHONE : '', colSpan: 3, className: 'iqDetailTableBodyBorder' },
      title2: { text: null },
      content2: { text: null },
    },
    {
      title1: { text: '사용용도', className: 'iqTableBorder' ,url: null},
      content1: { text: inquiry.IQ_USE ? inquiry.IQ_USE : '', colSpan: 3, className: 'iqDetailTableBodyBorder' },
      title2: { text: null },
      content2: { text: null },
    },
    {
      title1: { text: '구매제품', className: 'iqTableBorder' ,url: null},
      content1: { text: inquiry.IQ_PRD ? inquiry.IQ_PRD : '', colSpan: 3, className: 'iqDetailTableBodyBorder' },
      title2: { text: null },
      content2: { text: null },
    },
    {
      title1: { text: '제품수량', className: 'iqTableBorder' ,url: null},
      content1: { text: inquiry.IQ_QUANTITY ? inquiry.IQ_QUANTITY : '', colSpan: 3, className: 'iqDetailTableBodyBorder' },
      title2: { text: null },
      content2: { text: null },
    },
    {
      title1: { text: '작성일', className: 'iqTableBorder' ,url: null},
      content1: { text: formatDate(inquiry.IQ_INPUT_DATE), colSpan: 3, className: 'iqDetailTableBodyBorder' },
      title2: { text: null },
      content2: { text: null },
    },
    {
      title1: { text: '문의내용', className: 'iqTableBorder' },
      content1: { text: (<div dangerouslySetInnerHTML={{ __html: inquiry.IQ_CONTENT }} ></div>)
      , colSpan: 3, className: 'iqAsTitleTableBodyBorder' },
      title2: { text: null },
      content2: { text: null },
    },
    {
      title1: { text: '첨부파일', className: 'iqTableBorder' },
      content1: { text: 
      (<div>
        {iqFile && iqFile.map((file, index) => (
          <div key={file.IF_IDX}>
            <a href={SERVER_URL + file.IF_PATH} target='_blank'>첨부파일 {index+1}</a>
          </div>
        ))}
      </div>), colSpan: 3, className: 'iqDetailTableBodyBorder' },
      title2: { text: null },
      content2: { text: null },
    },
  ];

  const asHeaderData = [
    { text: '', value: 'title1', widthClass: 'inquertRegHeader' },
    { text: '', value: 'content1', widthClass: 'inquertRegHeader' },
    { text: '', value: 'title2', widthClass: 'inquertRegHeader' },
    { text: '', value: 'content2', widthClass: 'inquertRegHeader' },
  ];

  useEffect(() => {
    const inquiryDetailData = async () => {
      const iqData = await fetchInquiryDetailData(idx);
      
      if(isNull(iqData[0].IQ_PWD)) {
        setIqCert(true);
      } else {
        setIqCert(false);
      }

      setInquiry(iqData[0]);
      setIqFile(iqData[1].files);

      if(iqData[0].IQ_AS_STATUS === 'Y'){
        var obj0;
        var obj1;

        var obj2 = {
          title1: { text: null },
          content1: { text: (<div dangerouslySetInnerHTML={{ __html: iqData[0].IQ_AS_CONTENT }}></div>), className: 'iqDetailTableBodyBorder' ,colSpan: (isMobile() ? 4 : 3) },
          title2: { text: null},
          content2: { text: null },
        };

        if(isMobile()) {
          obj0 = {
            title1: { text: '답변제목', className: 'iqTableBorder', rowSpan: 1 },
            content1: { text: iqData[0].IQ_AS_TITLE ? iqData[0].IQ_AS_TITLE : '', colSpan: 3, className: 'iqAsTitleTableBodyBorder' },
            title2: { text: null },
            content2: { text: null },
          };
          obj1 = {
            title1: { text: '답변일', className: 'iqTableBorder', rowSpan: 1 },
            content1: { text: null },
            title2: { text: null },
            content2: { text: formatDate(iqData[0].IQ_AS_INPUT_DATE), colSpan: 3, className: 'iqAsDateTableBodyBorder' },
          };
          setAsBodyData([obj0, obj1, obj2]);
        } else {
          obj1 = {
            title1: { text: '답변내용', className: 'iqTableBorder', rowSpan: 2 },
            content1: { text: iqData[0].IQ_AS_TITLE ? iqData[0].IQ_AS_TITLE : '', className: 'iqAsTitleTableBodyBorder' },
            title2: { text: '작성일', className: 'iqTableBorder' },
            content2: { text: formatDate(iqData[0].IQ_AS_INPUT_DATE), className: 'iqAsDateTableBodyBorder' },
          };
          setAsBodyData([obj1, obj2]);
        }

      } else {
        setAsBodyData([]);
      }
      
    };
    
    inquiryDetailData();
    
  }, [idx]);

  return (
    <div>
      <HeaderComponents pageKey="support" />
      <div className='sideBannerComp flex-coulum'>
        <div>
          <SideBannerComponents pageKey="support" />
        </div>
        <div id={S.iqDetailWrap} className='com-content-wrap mt-200 mb-50'>
          <div style={{minHeight:'650px'}}>
            {iqCert ? (<>
              {isMobile() ? (
                <>
                  <BasicTable headers={headerData} items={mbBodyData} />
                </>
              ) : (
                <>
                  <BasicTable headers={headerData} items={bodyData} />
                </>
              )}
              <BasicTable headers={asHeaderData} items={asBodyData} /> 
              <div className='flex-row center mt-60'>
                <BackListBtn text='목록으로' path='/support/inquiry/1'/>
              </div>
            </>) : 
            <div className='center' id={S.pwdInputWrap}>
              <input type='password' id='iqPwd' name='pwd' value={iqPwd.pwd} onChange={setIqPwd} className={S.iqPwdInput} placeholder='비밀번호를 입력하세요.'/>
              <div className='flex-row jt-con-between'>
                <div className={S.iqBtn} onClick={handlePreviousPage}>목록</div>
                <div className={`${S.iqBtn} ${S.wtFont}`} onClick={handelPwdSubmit}>입력</div>
              </div>
            </div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InquiryDetailPage;